<template>
  <Button
    v-bind="$attrs"
    class="elsa-flat-button">
    <slot/>
  </Button>
</template>

<script>
import Button from './Button';

export default {
  name: "TertiaryButton",
  components: {
    Button,
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

.elsa-flat-button.el-button {
  color: $black;
  border: 2px solid #E6E6E6;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 0 10px;
  font-family: "SF Pro Display", sans-serif;
  font-size: 18px;
  line-height: 24px;
  height: 56px;

  &[disabled="true"]{
    color:rgba(59, 72, 88, 0.3);
  }
}
</style>
